import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { T } from "../constants";

const useStyles = makeStyles({
  field: { display: "flex", flexDirection: "column", gap: 6, marginBottom: 12 },
  label: { fontSize: 12, fontWeight: 600, color: T.fg },
  hint: { fontSize: 11, color: T.mutedFg },
  row: {
    display: "grid",
    gridTemplateColumns: "140px 1fr",
    gap: 12,
    padding: "6px 0",
    borderBottom: `1px solid ${T.borderSoft}`,
    fontSize: 13,
  },
  rowLabel: { color: T.mutedFg },
  rowValue: { color: T.fg, minWidth: 0, overflowWrap: "anywhere" },
});

/* The same row, for something already settled that the runner only reads. */
export function DetailRow({ label, children }) {
  const s = useStyles();
  return (
    <div className={s.row}>
      <span className={s.rowLabel}>{label}</span>
      <span className={s.rowValue}>{children ?? "-"}</span>
    </div>
  );
}

export default function FieldRow({ label, hint, children, htmlFor }) {
  const s = useStyles();
  return (
    <div className={s.field}>
      <label className={s.label} htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {hint && <span className={s.hint}>{hint}</span>}
    </div>
  );
}
